// extracted by mini-css-extract-plugin
module.exports = {"divider":"_d8b3831"};